import React from 'react';
import {useIntl} from 'react-intl';
import styles from './search-input.module.scss';

interface SearchInputProps {
  onChange?: (text: string) => void;
}

// Convenção nova: busca só filtra a partir de 4 caracteres -- texto de 1 a 3 letras equivale a
// vazio (sem filtro nenhum), em vez de filtrar uma tabela grande a cada tecla antes de haver o
// que restringir de fato. Digitar o 4º caractere aplica o filtro; apagar de volta pra menos de 4
// desfaz -- nunca fica um filtro "congelado" que não bate com o que está escrito no campo.
export const SEARCH_MIN_LENGTH = 4;

const SearchInput = (props: SearchInputProps) => {
  const intl = useIntl();
  // O número vem da constante: texto da dica e regra do filtro não divergem. A dica é curta de
  // propósito, para caber na largura padrão do campo sem ser cortada.
  const hint = intl.formatMessage({id: 'searchInputHint'}, {min: SEARCH_MIN_LENGTH});
  return (
    <div className={styles.container}>
      <input
        className={styles.input}
        type="text"
        placeholder={hint}
        style={{
          width: '100%',
          padding: '8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
        }}
        onChange={(e) => {
          const text = e.target.value;
          props.onChange?.(text.length >= SEARCH_MIN_LENGTH ? text : '');
        }}
      />
    </div>
  );
};
SearchInput.displayName = 'SearchInput';

export default SearchInput;
